import { render } from "./AddWarehouse.vue?vue&type=template&id=18bdcebe&scoped=true"
import script from "./AddWarehouse.vue?vue&type=script&lang=js"
export * from "./AddWarehouse.vue?vue&type=script&lang=js"

import "./AddWarehouse.vue?vue&type=style&index=0&id=18bdcebe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bdcebe"]])

export default __exports__